module.exports = __webpack_public_path__ + "img/airPurifiers_1_1.c811a12a.png";